import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'join'
})
export class JoinPipe implements PipeTransform {
  transform(
    values: Array<string>,
    separator: string = ',',
    filterEmptyOrNull: boolean = false
  ): string {
    if (!values) {
      return values;
    }

    if (filterEmptyOrNull) {
      values = values.filter((v) => !!v);
    }

    return values.join(separator);
  }
}
